import { ActionStatus } from '../../../../common/constants/action-status';
import { StoreState } from '../../../../store/store.interface';
import {
  InclusiveAccessBlock,
  MyDigitalProductAggregatedItem,
} from '../interface/my-digital-products-aggregated.interface';

export const getMyDigitalProductsAggregatedStatus = (state: StoreState) =>
  state.myDigitalProductsAggregatedState.status;

export const isLoadingMyDigitalProductsAggregated = (state: StoreState) =>
  state.myDigitalProductsAggregatedState.status === ActionStatus.loading;

export const isSucceededMyDigitalProductsAggregated = (state: StoreState) =>
  state.myDigitalProductsAggregatedState.status === ActionStatus.succeeded;

export const getMyDigitalProductsAggregatedData = (state: StoreState): MyDigitalProductAggregatedItem[] =>
  state.myDigitalProductsAggregatedState.data ?? [];

/**
 * Lookup helper for the merge-by-ISBN inside the existing tile renderer.
 * Returns the inclusiveAccess block for a given ISBN10, or null if absent.
 */
export const selectInclusiveAccessByIsbn10 =
  (isbn10: string) =>
  (state: StoreState): InclusiveAccessBlock | null => {
    const items = getMyDigitalProductsAggregatedData(state);
    const match = items.find((it) => it.identity.isbn10 === isbn10);
    return match?.inclusiveAccess ?? null;
  };
